import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, http } from "../../lib/api";
import { Btn } from "../kit/Kit";

export const sel = "w-full rounded-lg border border-[#E2DDD5] bg-white px-3 py-2 text-sm outline-none focus:border-[#E8643C]";
export const mxn = (v) => (v === null || v === undefined ? "—" : v.toLocaleString("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 }));

let cache = null;
export const useCatalogos = () => {
  const [c, setC] = useState(cache || { referenciadores: [], socios: [], ejecutivos: [], origenes: [], plazos: [] });
  useEffect(() => { if (!cache) http.get("/captacion/catalogos").then((r) => { cache = r.data; setC(r.data); }).catch(() => null); }, []);
  return c;
};

export const nombreDe = (c, id) => [...c.referenciadores, ...c.socios, ...c.ejecutivos].find((x) => x.id === id)?.nombre;

export const AsigForm = ({ ids, inicial = {}, onDone, testid = "cap-asig" }) => {
  const c = useCatalogos();
  const [f, setF] = useState({ referenciador_id: inicial.referenciador_id || "", socio_id: inicial.socio_id || "", ejecutivo_id: inicial.ejecutivo_id || "", origen: inicial.origen || "", motivo: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const guardar = async () => {
    const body = Object.fromEntries(Object.entries(f).map(([k, v]) => [k, v || (k === "motivo" ? "" : null)]));
    try {
      if (ids.length === 1) await http.put(`/captacion/ahorradores/${ids[0]}/asignacion`, body);
      else await http.post("/captacion/asignar-masivo", { ...body, ids });
      toast.success(`Asignación guardada (${ids.length})`);
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="grid gap-2 sm:grid-cols-2" data-testid={testid}>
      <select value={f.referenciador_id} onChange={set("referenciador_id")} className={sel} data-testid={`${testid}-ref`}><option value="">Sin referenciador</option>{c.referenciadores.map((x) => <option key={x.id} value={x.id}>{x.nombre}</option>)}</select>
      <select value={f.socio_id} onChange={set("socio_id")} className={sel} data-testid={`${testid}-socio`}><option value="">Sin socio</option>{c.socios.map((x) => <option key={x.id} value={x.id}>{x.nombre}</option>)}</select>
      <select value={f.ejecutivo_id} onChange={set("ejecutivo_id")} className={sel} data-testid={`${testid}-ejecutivo`}><option value="">Sin ejecutivo</option>{c.ejecutivos.map((x) => <option key={x.id} value={x.id}>{x.nombre}</option>)}</select>
      <select value={f.origen} onChange={set("origen")} className={sel} data-testid={`${testid}-origen`}><option value="">Origen automático</option>{c.origenes.map((x) => <option key={x}>{x}</option>)}</select>
      <input value={f.motivo} onChange={set("motivo")} placeholder="Motivo (opcional)" className={`${sel} sm:col-span-2`} data-testid={`${testid}-motivo`} />
      <Btn onClick={guardar} className="sm:col-span-2" data-testid={`${testid}-guardar`}>Asignar {ids.length > 1 ? `${ids.length} ahorradores` : ""}</Btn>
    </div>
  );
};
